const defaultTeam = 'All Teams';
const teams = [
    { seperator: true },
    { text: defaultTeam, value: 0, defaultItem: true },
    { seperator: true },
    { text: '1st Team', value: 771 },
    { text: '2nd Team', value: 3084 },
    { text: '3rd Team', value: 12336 },
    { text: '4th Team', value: 1966080 }
];

const defaultType = 'All Comps';
const types = [
    { seperator: true },
    { text: defaultType, value: 0, defaultItem: true },
    { seperator: true },
    { text: 'Herts League', value: 'HL' },
    { text: 'Chess Valley', value: 'CV' },
    { text: 'HCL T20', value: 'HCL T20' },
    { text: 'Friendly', value: 'Friendly' },
    { text: 'JDD', value: 'JDD' }
];

const defaultSeason = 'This Season';
const seasons = [
    { seperator: true },
    { text: defaultSeason, value: 2025, defaultItem: true },
    { seperator: true },
    { text: 'All Seasons', value: 'all' },
    { seperator: true },
    { text: '2024 Season', value: 2024 },
    { text: '2023 Season', value: 2023 },
    { text: '2022 Season', value: 2022 },
    { text: '2021 Season', value: 2021 },
    { text: '2020 Season', value: 2020 },
    { text: '2019 Season', value: 2019 },
    { text: '2018 Season', value: 2018 },
    { text: '2017 Season', value: 2017 },
    { text: '2016 Season', value: 2016 },
    { text: '2015 Season', value: 2015 },
    { text: '2014 Season', value: 2014 },
    { text: '2013 Season', value: 2013 },
    { text: '2012 Season', value: 2012 },
    { text: '2011 Season', value: 2011 },
    { text: '2010 Season', value: 2010 },
    { text: '2009 Season', value: 2009 },
    { text: '2008 Season', value: 2008 },
    { text: '2007 Season', value: 2007 },
    { text: '2006 Season', value: 2006 },
    { text: '2005 Season', value: 2005 },
    { text: '2004 Season', value: 2004 },
    { text: '2003 Season', value: 2003 },
    { text: '2002 Season', value: 2002 },
    { text: '2001 Season', value: 2001 },
    { text: '2000 Season', value: 2000 },
    { text: '1999 Season', value: 1999 }
];

const menuConfig = [
    {
        type: 'dropdown',
        id: 'team',
        initialText: 'All Teams',
        icon: 'group',
        items: teams
    },
    {
        type: 'dropdown',
        id: 'type',
        initialText: 'All Comps',
        icon: 'grid_on',
        items: types
    },
    {
        type: 'dropdown',
        id: 'season',
        initialText: 'This Season',
        icon: 'date_range',
        items: seasons
    }
];

const GlobalParamsStore = {
    getMenuConfig() {
        return menuConfig;
    }
};

export default GlobalParamsStore;



// WEBPACK FOOTER //
// ./src/stores/GlobalParamsStore.js